import type { DateAgnosticTimeRange } from "./date-agnostic-time-range";
import type {
    TimeToStringOptions} from "./date-agnostic-time-to-string";
import {
    dateAgnosticTimeToString
} from "./date-agnostic-time-to-string";

function dateAgnosticTimeRangeToString(
    range: DateAgnosticTimeRange,
    options?: TimeToStringOptions
): string {
    const ignoreMinutesIfZero = !!options?.ignoreMinutesIfZero;
    const ignoreMinutes =
        ignoreMinutesIfZero &&
        range.start.minute === 0 &&
        range.end.minute === 0;

    // TODO: above doesn't work when rendering for another timezone
    // TODO: where utc minutes and tz minutes aren't the same.
    // TODO: not important right now though

    return `${dateAgnosticTimeToString(range.start, {
        ignoreMinutesIfZero: ignoreMinutes,
    })}-${dateAgnosticTimeToString(range.end, {
        ignoreMinutesIfZero: ignoreMinutes,
    })}`;
}

export { dateAgnosticTimeRangeToString };
